import * as usersAPI from 'lib/api/service/users';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validatePhoneNumber } from 'utils/validate';
import { changeProp } from 'modules/serviceSlice';
import useLoginCheck from 'hooks/common/useLoginCheck';

export const useKidRow = (id, setShowResetModal) => {
  const queryClient = useQueryClient();

  const [inputs, setInputs] = useState({
    name: '',
    code: '',
    tel: '',
  });
  const { name, code, tel } = inputs;
  const newTel = tel.replace(/-/g, '');
  const [isTelValidated, setIsTelValidated] = useState(false);

  const updateMasterKidMutation = useMutation(usersAPI.updateMasterKid, {
    onSuccess: () => {
      queryClient.invalidateQueries('masterUsers');
    },
  });
  useLoginCheck(updateMasterKidMutation.error?.response, () => {
    updateMasterKidMutation.mutate({
      id,
      name,
      code,
      tel: newTel,
    });
  });

  const resetMasterKidMutation = useMutation(usersAPI.resetMasterKid, {
    onSuccess: () => {
      queryClient.invalidateQueries('masterUsers');
    },
  });
  useLoginCheck(resetMasterKidMutation.error?.response, () => {
    resetMasterKidMutation.mutate({ kidsUserId: id });
  });

  useEffect(() => {
    if (Object.keys(validatePhoneNumber(newTel)).length === 0) {
      setIsTelValidated(true);
    } else {
      setIsTelValidated(false);
    }
  }, [newTel]);

  const onUpdate = () => {
    updateMasterKidMutation.mutate({
      id,
      name,
      code,
      tel: newTel,
    });
  };

  const onChange = e => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const onReset = () => {
    resetMasterKidMutation.mutate({ kidsUserId: id });
    setShowResetModal(true);
  };

  return {
    name,
    code,
    tel,
    isTelValidated,
    onChange,
    onUpdate,
    onReset,
  };
};

const useUsersMasterTable = () => {
  const dispatch = useDispatch();
  const { userType } = useSelector(({ auth }) => auth);

  const getMasterUsers = useQuery('masterUsers', usersAPI.getMasterUsers);
  useLoginCheck(getMasterUsers.error?.response, getMasterUsers.refetch);

  useEffect(() => {
    if (getMasterUsers.error?.response.status === 500) {
      dispatch(changeProp({ key: 'serviceError', value: true }));
    }
  }, [getMasterUsers, dispatch]);

  return { userType, getMasterUsers };
};

export default useUsersMasterTable;
